import React from 'react';
import {
	BaasicInput,
	BaasicErrorModal,
	Loader,
	BaasicCheckbox,
	BaasicAsyncSelect,
	SliderCheckBox,
	BaasicSelect,
} from 'core/components';
import { defaultTemplate } from 'core/hoc';

const GeneralStepTemplate = ({
	t,
	form,
	productEditViewStore: {
		loading,
		checkValidity,
		checkMultiProduct,
		conditionOptions,
		productStatusOptions,
		productCategoryOptions,
		onCheck,
		onSearch,
		onChange,
		isUsualProductCreation,
		isMultiPackage,
		displaySellerDropdown,
		sellerOptions,
		isUpdateMethod,
		onSellerChange,
		addUpcField,
		removeUpc,
	},
}) => {
	if (loading) return <Loader />;

	return (
		<div>
			<section>
				<h3 className="spc--bottom--med title--primary">{t('PRODUCT.WIZARD.GENERALSTEP')}</h3>
				<div className="row">
					<div className="col col-sml-12 col-lrg-12 col-xxlrg-10">
						<div className="row">
							<div className="col col-sml-6">
								<div className="inputgroup spc--bottom--sml">
									<div className="flex--primary">
										{displaySellerDropdown && !isUpdateMethod && isUsualProductCreation && (
											<BaasicSelect
												field={form.$('seller')}
												options={sellerOptions}
												value={form.$('seller').value}
												isClearable={true}
												onChange={onSellerChange}
												placeholder={t('PLACEHOLDER.SELLER')}
												className="w--200--px spc--right--med"
											/>
										)}
									</div>
								</div>
								{isUsualProductCreation && (
									<div className="input--toggle--custom spc--bottom--sml">
										<SliderCheckBox field={form.$('isMultiPackage')} onValueChange={checkMultiProduct} />
									</div>
								)}
								{!isUsualProductCreation && (
									<BaasicInput field={form.$('productPartQuantity')} onValueChange={checkValidity} />
								)}
								<div className="inputgroup">
									<div className="inputgroup--main">
										<BaasicInput onValueChange={checkValidity} autoFocus field={form.$('mainSku')} />
									</div>
								</div>
								<BaasicInput field={form.$('asin')} className="w--100" />
								<BaasicInput onValueChange={checkValidity} field={form.$('name')} />

								<div className="spc--bottom--med">
									{form.$('productUpcs').map(productUpc => {
										return (
											<React.Fragment>
												<BaasicInput
													onValueChange={checkValidity}
													field={productUpc.$('upc')}
													innerClassName={form.$('productUpcs').value.length > 1 ? 'input--delete' : ''}
													iconClass={
														form.$('productUpcs').value.length > 1
															? 'fa fa-trash type--color--warning k-custom-clickable'
															: ''
													}
													onIconClick={() => removeUpc(productUpc.key)}
													className="input--no-label--first-child"
												/>
											</React.Fragment>
										);
									})}

									<span className="btn btn--primary btn--icon" onClick={addUpcField}>
										<i className="fa fa-plus"></i>
									</span>
								</div>

								<div className="inputgroup spc--bottom--sml">
									<BaasicAsyncSelect
										field={form.$('condition')}
										isClearable={true}
										loadOptions={input => onSearch(input, 'condition')}
										defaultOptions={conditionOptions}
										value={form.$('condition').value}
										onChange={value => onChange(value, form.$('condition'))}
									/>
								</div>
								<div className="inputgroup spc--bottom--sml">
									<BaasicAsyncSelect
										field={form.$('productStatus')}
										isClearable={true}
										loadOptions={input => onSearch(input, 'productStatus')}
										defaultOptions={productStatusOptions}
										value={form.$('productStatus').value}
										onChange={value => onChange(value, form.$('productStatus'))}
									/>
								</div>
							</div>
							<div className="col col-sml-6">
								<BaasicInput field={form.$('description')} className="w--100" />
								<div className="inputgroup spc--bottom--sml ss">
									<BaasicAsyncSelect
										field={form.$('productCategory')}
										isClearable={true}
										loadOptions={input => onSearch(input, 'productCategory')}
										defaultOptions={productCategoryOptions}
										value={form.$('productCategory').value}
										onChange={value => onChange(value, form.$('productCategory'))}
									/>
								</div>
								{!isMultiPackage && (
									<BaasicCheckbox
										id={form.$('onePerBox').id}
										onChange={onCheck}
										label="PRODUCTVIEW.ONEPERBOX"
										checked={form.$('onePerBox').value}
									/>
								)}
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};

export default defaultTemplate(GeneralStepTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/wizard/pages/GeneralStepTemplate.jsx